function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'2c04b7cd6557d8ff9aadfad19b79531b': 'rgb(47, 49, 46)','0e9a34e9a28cbe1e94ed6da20ce7e685': 'rgb(115, 96, 82)','1cd8a9b2b809df22c4c4b7334d58d5bd': 'rgb(212, 218, 216)','2f02c389110a7b258ce507d30331bb4d': 'rgb(135, 135, 135)','65726ea22c0cc79d47a05fdd55dc8252': 'rgb(231, 230, 226)','3d9f9e75963a374ec3fc1cc02ba5fc5f': 'rgb(169, 185, 172)',};

    this.images = {'87a4fef9661f72a95dfb8a98419de858': 'url("//waschbrett-europe.com/cdn/shop/files/BlackGreen_68x.png?v=4349592204269033535")','07250e78692b78e216e35587baf9a5e5': 'url("//waschbrett-europe.com/cdn/shop/files/BlackBlue_68x.png?v=10652764508901376326")','5ff572c7e23f5e98fde0f3253fff0a75': 'url("//waschbrett-europe.com/cdn/shop/files/BlackGold_68x.png?v=986199621903748800")','f12deb98ae0b2a9467f756dc00cce5d4': 'url("//waschbrett-europe.com/cdn/shop/files/BlackNatur_68x.png?v=11122195910718171399")',};
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) swatch.style.setProperty('--tick-color', '#000');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

window.theme.swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  window.theme.swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);
